import { useCallback, useState } from 'react'
import { type ColorChangeHandler, SketchPicker } from 'react-color'

interface ColorInputProps {
  defaultValue: string
  placeholder?: string
  predefinedColors?: string[]
  onChange: (color: string) => void
  className?: string
}

const ColorInput = ({
  defaultValue,
  placeholder,
  predefinedColors = [],
  onChange,
  className,
}: ColorInputProps) => {
  const [showColorPicker, setShowColorPicker] = useState<boolean>(false)
  const [color, setColor] = useState<string>(defaultValue)

  const handleColorChange: ColorChangeHandler = useCallback(
    (color) => {
      setColor(color.hex)
      onChange(color.hex)
    },
    [onChange],
  )
  const toggleColorPicker = useCallback(() => {
    setShowColorPicker((show) => !show)
  }, [])
  const closeColorPicker = useCallback(() => {
    setShowColorPicker(false)
  }, [])

  return (
    <div className={className}>
      <div
        onClick={toggleColorPicker}
        className="relative inline-block p-1 pl-8 border border-black rounded-sm text-xs leading-5 cursor-pointer"
      >
        <div
          className="absolute top-0 bottom-0 left-0 w-[28px] border-r border-black"
          style={{
            backgroundColor: color,
          }}
        />
        {placeholder}
      </div>

      {showColorPicker && (
        <div className="absolute py-4 z-10">
          <div
            onClick={closeColorPicker}
            className="fixed top-0 right-0 bottom-0 left-0"
          />
          <SketchPicker
            color={color}
            disableAlpha={true}
            width="320px"
            presetColors={predefinedColors}
            onChange={handleColorChange}
          />
        </div>
      )}
    </div>
  )
}

export default ColorInput
